import i18n from 'i18n';
import lodashGet from 'lodash.get';
import { ITooltipParams, ValueGetterParams } from '@ag-grid-community/core';
import {
  ColDef,
} from '@ag-grid-enterprise/all-modules';

export default function getFieldFromPropertyPathValueGetter<T, U>(
  propertyPath: string[],
): (params: Partial<ValueGetterParams> | Partial<ITooltipParams>) => string {
  return ({ data, colDef }: Partial<ValueGetterParams> | Partial<ITooltipParams>): string => {
    const value = lodashGet(data[(colDef as ColDef).field || ''], propertyPath);

    if (value == null) {
      return i18n.t('common.grid.empty');
    }

    return value;
  };
}
